<template>
	<div class="ml-12">
		<!-- 清空按钮 -->
		<el-button class="remove-btn" plain @click="Reset">{{translate.ShowText('清空')}}</el-button>
	</div>
</template>

<script lang="ts" setup>
	import translate from '@/api/translate';

	const emits = defineEmits(["change"]);

	const Reset = () => {
		emits("change");
	};
</script>

<style lang="scss" scoped>
	.remove-btn {
		padding: 0 12px;
		// width: 60px;
		height: 32px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 32px;
	}
</style>